import { render } from "./visualizar_turma.vue?vue&type=template&id=4238ab8f&scoped=true"
import script from "./visualizar_turma.vue?vue&type=script&lang=js"
export * from "./visualizar_turma.vue?vue&type=script&lang=js"

import "./visualizar_turma.vue?vue&type=style&index=0&id=4238ab8f&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4238ab8f"]])

export default __exports__